import { render } from "./QuestionnaireResetPassword.vue?vue&type=template&id=6e7513bb&scoped=true&ts=true"
import script from "./QuestionnaireResetPassword.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireResetPassword.vue?vue&type=script&lang=ts"

import "./QuestionnaireResetPassword.vue?vue&type=style&index=0&id=6e7513bb&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src599522923/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7513bb"]])

export default __exports__